import { REAL_BASE_URL } from "../api/axiosInstance";

/** Local path → API host; Cloudinary / S3 / blob URLs stay as-is. */
export function toMediaUrl(path, base = REAL_BASE_URL) {
  if (!path) return "";
  const value = String(path).trim();
  if (
    /^https?:\/\//i.test(value) ||
    value.startsWith("blob:") ||
    value.startsWith("data:")
  ) {
    return value;
  }
  const host = String(base || "").replace(/\/$/, "");
  return `${host}${value.startsWith("/") ? value : `/${value}`}`;
}
